<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  /* eslint no-console: ["error", { allow: ["info", "warn", "error"] }] */
  name: "app"
};
</script>
<style>
#app {
  justify-content: center;
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding: 4px;
}
</style>
